import { render, staticRenderFns } from "./CustomizeVariantCard.vue?vue&type=template&id=0bff7578&"
import script from "./CustomizeVariantCard.vue?vue&type=script&lang=js&"
export * from "./CustomizeVariantCard.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeVariantCard.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports